import React from 'react'
import { Container, Col, Row } from 'reactstrap'
import '../../Offer/offer.css'
var Translate = require('react-translate-component')
export default class Gardens2 extends React.Component {
  render () {
    return (
      <Container className='servicesContentContainer'>
        <Row>
          <Col md='12' sm='12' id='gardensDesc' className='contentDescription '>
            <p className='contentConstructionDescription'>
              <Translate content='pracujemy_na_najwyzszej' />
              <b>
                <Translate content='schuco_aluprof' />
              </b>
            </p>
            <p className='contentConstructionDescription'>
              <Translate content='oferujemy_szklo' />
            </p>
          </Col>
        </Row>
      </Container>
    )
  }
}
